module.exports = {
    appName: 'Medicin',
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? 'https://api.medicin.in/api/v1' : 'http://localhost:3000/api/v1'),
    CURRENCY_SYMBOL: '₹',
    DEFAULT_PROFILE_IMAGE: 'https://cdn-icons-png.flaticon.com/512/147/147142.png',
};